import { useTranslations } from "next-intl";
import { cn } from "@/lib/cn";

const STEP_KEYS = ["you", "details", "matches", "photos"] as const;

/** Slim 4-step progress indicator for the join wizard. */
export function Stepper({ current }: { current: number }) {
  const t = useTranslations("join.stepper");
  return (
    <ol className="flex items-center gap-2">
      {STEP_KEYS.map((stepKey, i) => {
        const step = i + 1;
        const active = step === current;
        const done = step < current;
        return (
          <li
            key={stepKey}
            aria-current={active ? "step" : undefined}
            className="flex flex-1 flex-col gap-1.5"
          >
            <div
              aria-hidden
              className={cn(
                "h-1 rounded-full transition-colors duration-300",
                done || active ? "bg-flamingo" : "bg-white/10",
              )}
            />
            <span
              className={cn(
                "text-2xs font-medium transition-colors",
                active ? "text-white" : done ? "text-flamingo/80" : "text-white/50",
              )}
            >
              {t(stepKey)}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
